import TarjetaModulo from './TarjetaModulo';

export const ListadoModulos = ({ rows }) => {


  return (
    <>
      {rows.map((row, index) => (
        <TarjetaModulo
          key={index}
          modulo={row.tipoModulo.modulo}
          estado={row.estado}
          ultimaConexion={row.ultima_conexion}
          ultimaMedicion={row.ultima_medicion}
        />
      ))}
    </>
  );
};
